import { Link } from "@quintype/components";
import { object } from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import React from "react";

import { SvgIconHandler } from "../../../../atoms/svg-icon-hadler";

import "./bread-crumbs.m.css";

const Breadcrumbs = ({ story }) => {
  if (!story) {
    return null;
  }

  const sectionInfo = get(story, ["sections", "0"]);
  const sections = useSelector((state) => get(state, ["qt", "config", "sections"], []));
  const parentSectionInfo = sections.find((item) => item.id === sectionInfo["parent-id"]);
  const isPhotoStory = get(story, ["story-template"]) === "photo";
  const photoStoryStyle = isPhotoStory ? "photo-story-style" : "";

  return (
    <div styleName={`breadcrumbs ${photoStoryStyle}`} data-test-id="breadcrumbs" className="breadcrumb-wrapper">
      <Link href="/" aria-label="home page" data-test-id="home-section">
        <SvgIconHandler type="home-icon" width="24" height="24" viewBox="0 0 24 24" />
      </Link>
      <SvgIconHandler className="chevron" type="down-chevron" width="24" height="24" viewBox="0 0 12 12" />
      {parentSectionInfo && (
        <>
          <Link href={`/${parentSectionInfo.slug}`} aria-label="parent-section" data-test-id="parent-section">
            {parentSectionInfo["display-name"] || parentSectionInfo.name}
          </Link>
          <SvgIconHandler className="chevron" type="down-chevron" width="24" height="24" viewBox="0 0 12 12" />
        </>
      )}
      <Link href={`/${sectionInfo.slug}`} aria-label="section" data-test-id="sub-section">
        {sectionInfo["display-name"] || sectionInfo.name}
      </Link>
    </div>
  );
};

Breadcrumbs.propTypes = {
  story: object,
};

export default Breadcrumbs;
